'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z' });

var DirectionsRailway = function DirectionsRailway(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

DirectionsRailway = (0, _pure2.default)(DirectionsRailway);
DirectionsRailway.muiName = 'SvgIcon';

exports.default = DirectionsRailway;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/DirectionsRailway.js
// module id = 2321
// module chunks = 0